import {Soprintendenza, User} from '@/types/user';

interface LoggedUserState {
  id: number,
  role: string,
  email: string,
  username: string,
  authToken: string
}

export default {
  namespaced: true,
  state: ():LoggedUserState => ({
    id: 0,
    role: "",
    email: "",
    username: "",
    authToken: "",
  }),
  mutations: {
    resetState(state: LoggedUserState) {
      state.id = 0;
      state.authToken = '';
      state.role = "";
      state.email = "";
      state.username = '';
    },
    setUser(state: LoggedUserState, user:User) {
      state.id = user.id;
      state.role = user.role;
      state.username = user.username;
      state.email = user.email;
    },
    setUsername(state: LoggedUserState, username: string) {
      state.username = username;
    },
    setRole(state: LoggedUserState, role: string) {
      state.role = role;
    },
    setEmail(state: LoggedUserState, email: string) {
      state.email = email;
    },
    setAuthToken(state: LoggedUserState, authToken: string) {
      state.authToken = authToken;
    },
  },
  getters: {
    loggedUser(state: LoggedUserState) : User {
      return {
        id: state.id,
        username: state.username,
        email: state.email,
        role: state.role,
      };
    },
    loggedUserAuthToken(state: LoggedUserState) : string {
      return state.authToken;
    },
    loggedUserUsername(state: LoggedUserState) : string {
      return state.username;
    },
    loggedUserRole(state: LoggedUserState): string {
      return state.role;
    },
    loggedUserEmail(state: LoggedUserState): string {
      return state.email;
    },
    loggedUserId(state: LoggedUserState) : number {
      return state.id;
    },
  },
};
